import React from "react";
import {Button, Checkbox, Divider, List, Radio} from "antd";
import connect from "react-redux/es/connect/connect";
import {injectIntl} from "react-intl";
import {withAuthorization} from "../../services/Authorization";
import SATimePicker from "../common/input/SATimePicker";
import Storage from "../../services/Storage";
import LabelEncoder from "./LabelEncoder";
import Time from "../../services/Time";
import Constants from "../../services/Constants";
import {SpinnerModal} from "../../public/components/SpinnerModal";

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

const supportedLanguages = ['en', 'de', 'fr', 'nl'];

class GeneralServices extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      mainServices: {
        offering: {},
        receptionOffering: {}
      }
    }
  }

  componentDidMount() {
    this.props.dispatchFetchMainServices();
  }

  componentWillReceiveProps = (nextProps) => {
    const mainServices = nextProps.fetchMainServices && nextProps.fetchMainServices.mainServices;
    if (mainServices) {
      mainServices.receptionOffering = mainServices.receptionOffering || {};
      mainServices.manualRentalCarPlanning = mainServices.manualRentalCarPlanning || false;
      this.setState({mainServices});
    }
  };

  save = () => {
    let errors = {};
    if (Object.keys(errors).length === 0) {
      this.props.dispatchSaveMainServices(this.state.mainServices);
    }
  };

  onTimePickerChange = (time, timeString, name) => {
    const duration = time ? `PT${time.hour()}H${time.minute()}M` : undefined;
    const mainServices = this.state.mainServices;
    mainServices[name] = duration;
    this.setState({mainServices});
  };

  onCheckboxItemChange = (e) => {
    const {mainServices} = this.state;
    const {name, checked} = e.target
    mainServices[name] = checked;

    if (name === 'bmw' && !mainServices[name]) {
      mainServices['sendWarrantyMessageBmw'] = false;
    }
    if (name === 'mini' && !mainServices[name]) {
      mainServices['sendWarrantyMessageMini'] = false;
    }
    this.setState({mainServices});
  };

  on247OfferingChange = (e, incompatibleProps, resetIncompatibility) => {
    const {mainServices} = this.state;
    mainServices.offering = mainServices.offering || {};

    mainServices.offering[e.target.name] = e.target.checked;
    if (!e.target.checked && incompatibleProps && (!resetIncompatibility || resetIncompatibility())){
      incompatibleProps.forEach(prop=>mainServices.offering[prop]=false);
    }
    this.setState({mainServices});
  };

  parkingOrLockEnabled = () => {
    const {mainServices} = this.state;
    return mainServices.offering && (mainServices.offering.parking || mainServices.offering.lock);
  };

  isOfferingOptionEnabled = (prop) => {
    const {mainServices} = this.state;
    return mainServices.offering && mainServices.offering[prop];
  };

  onAutomaticWarrantyChange = (e) => {
    const {mainServices} = this.state;
    const {name, checked} = e.target;
    mainServices[name] = checked;
    this.setState({mainServices});
  };

  removeHolidaysAnnounce = () => {
    const {mainServices} = this.state;

    if (!mainServices || !mainServices.holidaysAnnounce) {
      return null;
    }
    mainServices.holidaysAnnounce = {};
    this.setState({mainServices});
  };

  onFastlaneChange = (e, brand) => {
    const {mainServices} = this.state;
    mainServices.receptionOffering = mainServices.receptionOffering || {};
    mainServices.receptionOffering[brand] = {
      ...(mainServices.receptionOffering[brand] || {}),
      fastlaneDesk: e.target.checked
    };
    this.setState({mainServices});
  };

  onDriveInChange = (e, brand) => {
    const {mainServices} = this.state;
    const {name, checked} = e.target;
    const driveIn = checked ? name : Constants.DRIVE_IN_NONE;

    mainServices.receptionOffering = mainServices.receptionOffering || {};
    mainServices.receptionOffering[brand] = {
      ...(mainServices.receptionOffering[brand] || {}),
      driveIn
    };
    this.setState({mainServices});
  };

  onWorkspaceReservationChange = e => {
    const {mainServices} = this.state;
    mainServices.receptionOffering = mainServices.receptionOffering || {};
    mainServices.receptionOffering[e.target.name] = e.target.checked;
    this.setState({mainServices});
  };

  onRentalPlanningTypeChange = (e) => {
    const {mainServices} = this.state;
    mainServices.manualRentalCarPlanning = e.target.value;
    this.setState({mainServices});
  };

  renderHolidaysAnnounce = () => {
    const {intl, intl: {formatMessage}} = this.props;
    const user = Storage.getItem('user');
    const canWrite= user.role === 'DUI_ADMIN';

    const {mainServices} = this.state;
    if (!mainServices || !mainServices.holidaysAnnounce || Object.keys(mainServices.holidaysAnnounce).length === 0) {
      return null;
    }
    const {holidaysAnnounce} = mainServices;
    return (
      <div>
        <span>{formatMessage({id: `${intl.locale}`})} : {holidaysAnnounce[intl.locale]}</span>&nbsp;
        {canWrite && <a className={"smaller"} onClick={this.removeHolidaysAnnounce}>{formatMessage({id:'action.delete'})}</a>}
      </div>
    )
  };

  onValidateHolidays = (values) => {
    const {mainServices} = this.state;

    mainServices.holidaysAnnounce = mainServices.holidaysAnnounce || {};

    supportedLanguages.forEach(lg=>{
      mainServices['holidaysAnnounce'][lg] = values[lg];
    });

    this.setState({mainServices});
  };

  render() {
    const {intl:{formatMessage}, fetchMainServices, loading, saveMainServices, configurationHints} = this.props;
    const {mainServices} = this.state;
    const user = Storage.getItem('user');
    const canWrite= user.role === 'DUI_ADMIN';

    const serviceListError = saveMainServices && saveMainServices.error && saveMainServices.error.content && saveMainServices.error.content.mainServices;
    const offeringError = saveMainServices && saveMainServices.error && saveMainServices.error.content && saveMainServices.error.content.offering;

    const requiredConfig = configurationHints.includes('MAIN_SERVICES');

    const {bmwOffering = {}, miniOffering = {}} = mainServices.receptionOffering;
    return (
      <section className="box">
        <header className="box-heading">
          <h2 className="box-heading__title">
            {formatMessage({id:'section.general-services.title'})}
          </h2>
          {canWrite &&
            <div className="box-heading__button">
              <button onClick={this.save} disabled={loading} type="primary" className="btn btn-sm btn-primary">
                {formatMessage({id: 'action.save'})}
              </button>
            </div>
          }
        </header>
            <div className="box__body">

              {requiredConfig && <div className={"alert alert--error"}>{formatMessage({id:'section.requires-configuration'}, {sectionName:formatMessage({id:'section.general-services.title'})})}</div>}


              <SpinnerModal visible={loading}/>

              <div className="row">
                <div className="col-md-6 col-xxl-6">
                  <h3 className="box__subtitle">{formatMessage({id:'section.general-services.services.title'})}</h3>

                  <List className="list">
                    <List.Item>
                      <Checkbox name="bmw" disabled={!canWrite} checked={mainServices.bmw} onChange={this.onCheckboxItemChange}>
                        {formatMessage({id: 'intervention.brand.BMW'})}
                      </Checkbox>
                      {mainServices.bmw &&
                        <Checkbox name="sendWarrantyMessageBmw" disabled={!canWrite} checked={mainServices.sendWarrantyMessageBmw} onChange={this.onAutomaticWarrantyChange}>
                          {formatMessage({id:'general-services.automaticWarrantyBmw'})}
                        </Checkbox>
                      }
                    </List.Item>
                    <List.Item>
                      <Checkbox name="bmwi" disabled={!canWrite} checked={mainServices.bmwi} onChange={this.onCheckboxItemChange}>
                        {formatMessage({id: 'intervention.brand.BMWi'})}
                      </Checkbox>
                    </List.Item>
                    <List.Item>
                      <Checkbox name="mini" disabled={!canWrite} checked={mainServices.mini} onChange={this.onCheckboxItemChange}>
                        {formatMessage({id: 'intervention.brand.MINI'})}
                      </Checkbox>
                      {mainServices.mini &&
                        <Checkbox name="sendWarrantyMessageMini" disabled={!canWrite} checked={mainServices.sendWarrantyMessageMini} onChange={this.onAutomaticWarrantyChange}>
                          {formatMessage({id:'general-services.automaticWarrantyMini'})}
                        </Checkbox>
                      }
                    </List.Item>
                    <List.Item>
                      <Checkbox name="bodyshop" disabled={!canWrite} checked={mainServices.bodyshop} onChange={this.onCheckboxItemChange}>
                        {formatMessage({id: 'intervention.type.BODYSHOP'})}
                      </Checkbox>
                    </List.Item>
                  </List>
                  {serviceListError && <div className="txt-error">{formatMessage({id:serviceListError.message})}</div>}
                </div>
                <div className="col-md-6 col-xxl-6">
                  <h3 className="box__subtitle">{formatMessage({id:'section.general-services.waiting-time.title'})}</h3>

                  {canWrite ? <SATimePicker
                    onChange={(duration, time) => this.onTimePickerChange(duration, time, 'maxWaitingTime')}
                    error={saveMainServices.error && saveMainServices.error.content && saveMainServices.error.content.maxWaitingTime}
                    placeholder={formatMessage({id: 'placeholder.duration'})}
                    value={fetchMainServices.mainServices.maxWaitingTime}

                  />
                    :
                   <span>{(fetchMainServices.mainServices.maxWaitingTime) ? Time.durationToMoment(fetchMainServices.mainServices.maxWaitingTime, 'HH:mm').format('HH:mm') : ''}</span>
                  }

                </div>
              </div>
              <Divider/>
              <div className="row">
                <div className="col-md-6 col-xxl-6">
                  <h3 className="box__subtitle">{formatMessage({id: 'section.general-services.holidays.title'})}</h3>

                  <ul className="list">
                  {this.renderHolidaysAnnounce()}

                    {canWrite && <LabelEncoder keys={supportedLanguages}
                                onValidate={this.onValidateHolidays}
                                values={mainServices.holidaysAnnounce}>
                    <li className="list__footer">
                      <Button className="btn btn-link js-dropdown-trigger add-more-btn">
                        <svg className="bmw-icon-sm mr-1" aria-hidden="true">
                          <use xlinkHref="#icon-plus"/>
                        </svg>
                        <strong>{formatMessage({id:'section.general-services.setAnnounce'})}</strong>
                      </Button>
                    </li>
                  </LabelEncoder>}
                </ul>
                </div>
                <div className="col-md-6 col-xxl-6">
                  <h3 className="box__subtitle">{formatMessage({id:'section.rentalPlanning.title'})}</h3>

                  <div>
                    <RadioGroup value={mainServices.manualRentalCarPlanning} onChange={this.onRentalPlanningTypeChange} disabled={!canWrite}>
                      <RadioButton value={false}>{formatMessage({id: 'planningHandling.automatic'})}</RadioButton>
                      <RadioButton value={true}>{formatMessage({id: 'planningHandling.manual'})}</RadioButton>
                    </RadioGroup>
                  </div>
                </div>
              </div>
              <Divider/>
              <div className="row">
                <div className="col-md-6 col-xxl-6">
                  <h3 className="box__subtitle">{formatMessage({id:'section.247-offering.title'})}</h3>

                  <ul className="list li-margin">
                    <li>
                      {canWrite
                        ?
                      <Checkbox name="parking" checked={mainServices.offering && mainServices.offering.parking}
                                onChange={e=>this.on247OfferingChange(e, ['carPickup', 'rentalDropOff', 'carDropOff', 'rentalPickup'], ()=>!this.parkingOrLockEnabled())}>
                        {formatMessage({id: 'general-services.customerParking'})}
                      </Checkbox>
                       :
                      <Checkbox disabled={true} checked={mainServices.offering && mainServices.offering.parking}>
                        {formatMessage({id: 'general-services.customerParking'})}
                      </Checkbox>
                      }
                    </li>
                    <li>
                      {canWrite
                        ?
                        <Checkbox name="lock" checked={mainServices.offering && mainServices.offering.lock}
                                  onChange={e => this.on247OfferingChange(e, ['carPickup', 'rentalDropOff', 'carDropOff', 'rentalPickup'], () => !this.parkingOrLockEnabled())}>
                          {formatMessage({id: 'general-services.lockPark'})}
                        </Checkbox>
                        :
                        <Checkbox disabled={true} checked={mainServices.offering && mainServices.offering.lock}>
                          {formatMessage({id: 'general-services.lockPark'})}
                        </Checkbox>

                      }
                    </li>
                    {this.parkingOrLockEnabled() &&
                    <li>
                      {canWrite
                        ?
                        <Checkbox name="carPickup" checked={mainServices.offering && mainServices.offering.carPickup}
                                  disabled={!this.parkingOrLockEnabled()}
                                  onChange={e => this.on247OfferingChange(e, ['rentalDropOff'])}>
                          {formatMessage({id: 'general-services.carPickup.keySafe'})}
                        </Checkbox>
                        :
                        <Checkbox disabled={true} checked={mainServices.offering && mainServices.offering.carPickup}>
                            {formatMessage({id: 'general-services.carPickup.keySafe'})}
                        </Checkbox>
                      }
                      {this.isOfferingOptionEnabled('carPickup') && (canWrite
                            ?
                        <Checkbox name="rentalDropOff" checked={mainServices.offering && mainServices.offering.rentalDropOff}
                                  disabled={!this.isOfferingOptionEnabled('carPickup')}
                                  onChange={e => this.on247OfferingChange(e)}>
                          {formatMessage({id: 'general-services.rentalCar.dropOff'})}
                        </Checkbox>
                        :
                        <Checkbox disabled={true} checked={mainServices.offering && mainServices.offering.rentalDropOff}>
                          {formatMessage({id: 'general-services.rentalCar.dropOff'})}
                        </Checkbox>
                      )
                      }
                    </li>
                    }
                    {this.parkingOrLockEnabled() &&
                    <li>
                      {canWrite
                        ?
                        <Checkbox name="carDropOff" checked={mainServices.offering && mainServices.offering.carDropOff}
                                  disabled={!this.parkingOrLockEnabled()}
                                  onChange={e => this.on247OfferingChange(e, ['rentalPickup'])}>
                          {formatMessage({id: 'general-services.carDropOff.keySafe'})}
                        </Checkbox>
                        :
                        <Checkbox disabled={true} checked={mainServices.offering && mainServices.offering.carDropOff}>
                          {formatMessage({id: 'general-services.carDropOff.keySafe'})}
                        </Checkbox>

                      }
                      {this.isOfferingOptionEnabled('carDropOff') && (canWrite ?
                        <Checkbox name="rentalPickup" checked={mainServices.offering && mainServices.offering.rentalPickup}
                                disabled={!this.isOfferingOptionEnabled('carDropOff')}
                                onChange={e => this.on247OfferingChange(e)}>
                          {formatMessage({id: 'general-services.rentalCar.pickup'})}
                        </Checkbox>
                          :
                          <Checkbox disabled={true} checked={mainServices.offering && mainServices.offering.rentalPickup}>
                            {formatMessage({id: 'general-services.rentalCar.dropOff'})}
                          </Checkbox>
                      )
                      }
                    </li>
                    }

                  </ul>
                  {offeringError && <div className="txt-error">{formatMessage({id:offeringError.message})}</div>}
                </div>

                <div className="col-md-6 col-xxl-6">
                  <h3 className="box__subtitle">{formatMessage({id:'section.reception-offering.title'})}</h3>
                  <div className="row">
                    <div className="col-md-6 col-xxl-6">
                      <h3 className="box__subtitle">Bmw</h3>
                      <ul className="list li-margin">
                        <li>
                          <Checkbox name={Constants.DRIVE_IN_MANDATORY}
                                    checked={bmwOffering.driveIn === Constants.DRIVE_IN_MANDATORY}
                                    onChange={e => this.onDriveInChange(e, 'bmwOffering')}
                                    disabled={!canWrite}
                          >
                            {formatMessage({id: 'general-services.mandatoryDriveIn'})}</Checkbox>
                        </li>
                        {bmwOffering.driveIn !== Constants.DRIVE_IN_MANDATORY &&
                          <li>
                            <Checkbox name={Constants.DRIVE_IN_ON_REQUEST}
                                      checked={bmwOffering.driveIn === Constants.DRIVE_IN_ON_REQUEST}
                                      onChange={e => this.onDriveInChange(e, 'bmwOffering')}
                                      disabled={!canWrite}
                            >
                              {formatMessage({id: 'general-services.driveInOnRequest'})}
                            </Checkbox>
                          </li>
                        }
                        <li>
                          <Checkbox checked={bmwOffering.fastlaneDesk}
                                    onChange={e => this.onFastlaneChange(e, 'bmwOffering')}
                                    disabled={!canWrite}
                          >
                            {formatMessage({id: 'general-services.fastlane'})}
                          </Checkbox>
                        </li>
                      </ul>
                    </div>

                    <div className="col-md-6 col-xxl-6">
                      <h3 className="box__subtitle">Mini</h3>
                      <ul className="list li-margin">
                        <li>
                          <Checkbox name={Constants.DRIVE_IN_MANDATORY}
                                    checked={miniOffering.driveIn === Constants.DRIVE_IN_MANDATORY}
                                    onChange={e => this.onDriveInChange(e, 'miniOffering')}
                                    disabled={!canWrite}
                          >
                            {formatMessage({id: 'general-services.mandatoryDriveIn'})}
                          </Checkbox>
                        </li>
                        {miniOffering.driveIn !== Constants.DRIVE_IN_MANDATORY &&
                          <li>
                            <Checkbox name={Constants.DRIVE_IN_ON_REQUEST}
                                      checked={miniOffering.driveIn === Constants.DRIVE_IN_ON_REQUEST}
                                      onChange={e => this.onDriveInChange(e, 'miniOffering')}
                                      disabled={!canWrite}
                            >
                              {formatMessage({id: 'general-services.driveInOnRequest'})}
                            </Checkbox>
                          </li>
                        }
                        <li>
                          <Checkbox checked={miniOffering.fastlaneDesk}
                                    onChange={e => this.onFastlaneChange(e, 'miniOffering')}
                                    disabled={!canWrite}
                          >
                            {formatMessage({id: 'general-services.fastlane'})}
                          </Checkbox>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <Divider />

                  <Checkbox name={'workspaceReservations'} checked={mainServices.receptionOffering && mainServices.receptionOffering.workspaceReservations}
                            disabled={!canWrite} onChange={this.onWorkspaceReservationChange}>
                    {formatMessage({id: 'general-services.workspace'})}
                  </Checkbox>
                </div>
              </div>
          </div>
      </section>
    )
  }
}

const mapStateToProps = state => ({
  fetchMainServices: state.fetchMainServices,
  saveMainServices: state.saveMainServices,
  loading: state.fetchMainServices.loading || state.saveMainServices.loading,
  configurationHints: state.dealerConfigurationCheck && state.dealerConfigurationCheck.configurationHints || [],
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchMainServices: () => dispatch({type: 'FETCH_MAIN_SERVICES.REQUEST'}),
  dispatchSaveMainServices: (body) => dispatch({type: 'SAVE_MAIN_SERVICES.REQUEST', body})
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthorization(injectIntl(GeneralServices), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));



// WEBPACK FOOTER //
// ./src/components/dealership/GeneralServices.js